import styled from '@emotion/styled';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';

export const SecondaryNavWrapper = styled.div`
  display: flex;
  column-gap: ${SPACING.LG};
  height: 100%;
  // fix for NavMapper z-index
  z-index: -1;
`;
